import request from "@utils/request";

const ContractService = {
    /**
     * 查询 合同 列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6411
     */
    queryList(data) {
        return request({
            url: "/service/mg/contract/list",
            // url: "/service/mg/user/list", // todo 未确定接口
            method: "POST",
            data
        });
    },
    /**
     * 结束合同
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6477
     */
    endContract(data) {
        return request({
            url: "/service/mg/contract/status", // todo 未确定接口
            method: "put",
            data
        });
    },
    /**
     * 新增/编辑合同
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6475
     */
    editContract(data) {
        return request({
            url: "/service/mg/contract/save",
            method: "post",
            data
        });
    },
    /**
     * 查看 合同文件
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6476
     */
    getContractFile(data) {
        return request({
            url: "/service/mg/contract/get",
            method: "post",
            data
        });
    },
    /**
     * 查看 合同文件
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6476
     */
    getOneFile(data) {
        return request({
            url: "/service/dubbo/proxy/file/preview-file",
            method: "post",
            data
        });
    },
};

export default ContractService;
